import LegalLayout from './LegalLayout';
import Seo from '../components/Seo';

export default function KVKK() {
  return (
    <LegalLayout title="Kişisel Verilerin Korunması Hakkında Aydınlatma Metni">
      <Seo
        title="KVKK Aydınlatma Metni | Mahallebi"
        description="6698 sayılı KVKK kapsamında Mahallebi platformunda kişisel verilerin işlenme süreçlerine ilişkin aydınlatma metni."
        path="/kvkk"
      />
      <p className="text-sm text-gray-500 mb-6">Son güncelleme: 29 Mart 2026</p>

      <p className="mb-6">
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, UBS Bilişim Teknolojileri
        ("Şirket") olarak veri sorumlusu sıfatıyla kişisel verilerinizin korunmasına büyük önem veriyoruz.
        Bu aydınlatma metni, Mahallebi platformu üzerinden toplanan kişisel verilerinizin işlenme
        süreçleri hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.
      </p>

      <Section title="1. Veri Sorumlusu">
        <ul className="list-none space-y-1">
          <li><strong>Unvan:</strong> UBS Bilişim Teknolojileri</li>
          <li><strong>E-posta:</strong>{' '}
            <a href="mailto:info@ubsbilisim.com" className="text-[#e77e23] hover:underline">info@ubsbilisim.com</a>
          </li>
          <li><strong>Web:</strong>{' '}
            <a href="https://www.ubsbilisim.com" target="_blank" rel="noopener noreferrer" className="text-[#e77e23] hover:underline">www.ubsbilisim.com</a>
          </li>
        </ul>
      </Section>

      <Section title="2. İşlenen Kişisel Veriler">
        <table className="w-full text-sm border-collapse mb-4">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 pr-4 font-semibold">Veri Kategorisi</th>
              <th className="text-left py-2 font-semibold">Veriler</th>
            </tr>
          </thead>
          <tbody className="text-gray-600">
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">Kimlik verileri</td>
              <td className="py-2">Ad, soyad, kullanıcı adı, profil fotoğrafı</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">İletişim verileri</td>
              <td className="py-2">E-posta adresi, telefon numarası</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">Konum verileri</td>
              <td className="py-2">GPS koordinatları, mahalle, ilçe, il bilgisi</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">Görsel veriler</td>
              <td className="py-2">Profil fotoğrafı, ilan görselleri</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">İşlem güvenliği</td>
              <td className="py-2">IP adresi, giriş/çıkış kayıtları, cihaz bilgileri</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">Kullanım verileri</td>
              <td className="py-2">İlan geçmişi, arama kayıtları, beğeniler, değerlendirmeler</td>
            </tr>
            <tr>
              <td className="py-2 pr-4">İletişim içerikleri</td>
              <td className="py-2">Platform üzerinden gönderilen mesajlar</td>
            </tr>
          </tbody>
        </table>
      </Section>

      <Section title="3. Kişisel Verilerin İşlenme Amaçları">
        <p className="mb-3">Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Üyelik işlemlerinin yürütülmesi ve kimlik doğrulama</li>
          <li>Konum bazlı hizmetlerin sunulması (yakın ilanlar, komşu eşleştirmesi)</li>
          <li>Acil yardım taleplerinin işlenmesi ve yakın kullanıcılara bildirilmesi</li>
          <li>Güven puanı hesaplama ve rozet sistemi işletimi</li>
          <li>Platform güvenliğinin sağlanması ve kötüye kullanımın önlenmesi</li>
          <li>İçerik moderasyonu ve topluluk kurallarının uygulanması</li>
          <li>Kullanıcı destek taleplerinin karşılanması</li>
          <li>İstatistiksel analiz ve hizmet iyileştirmesi (anonimleştirilmiş verilerle)</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        </ul>
      </Section>

      <Section title="4. Kişisel Verilerin İşlenme Hukuki Sebepleri">
        <p className="mb-3">KVKK'nın 5. ve 6. maddeleri uyarınca kişisel verileriniz aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Açık rıza:</strong> Konum verileri, push bildirimleri, profil fotoğrafı</li>
          <li><strong>Sözleşmenin ifası:</strong> Hesap oluşturma, ilan yayınlama, mesajlaşma</li>
          <li><strong>Hukuki yükümlülük:</strong> Yasal saklama yükümlülükleri, resmi makam talepleri</li>
          <li><strong>Meşru menfaat:</strong> Platform güvenliği, hata izleme, hizmet iyileştirme</li>
        </ul>
      </Section>

      <Section title="5. Kişisel Verilerin Aktarılması">
        <p className="mb-3">Kişisel verileriniz, KVKK'nın 8. ve 9. maddeleri uyarınca aşağıdaki taraflara aktarılabilir:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Altyapı sağlayıcıları:</strong> Supabase (veritabanı - AB/ABD), Cloudflare (CDN - küresel), Sentry (hata izleme - AB)</li>
          <li><strong>İletişim hizmeti:</strong> Twilio (SMS doğrulama - ABD)</li>
          <li><strong>Kimlik doğrulama:</strong> Google OAuth (giriş hizmeti)</li>
          <li><strong>Yasal makamlar:</strong> Mahkeme kararı veya yasal zorunluluk halinde yetkili kamu kurum ve kuruluşları</li>
        </ul>
        <p className="mt-3">
          Yurt dışına veri aktarımı, KVKK'nın 9. maddesi kapsamında yeterli korumanın bulunduğu ülkelere
          veya yeterli korumanın taahhüt edildiği veri işleyenlere yapılmaktadır.
        </p>
      </Section>

      <Section title="6. Veri Saklama Süreleri">
        <table className="w-full text-sm border-collapse mb-4">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 pr-4 font-semibold">Veri Türü</th>
              <th className="text-left py-2 font-semibold">Saklama Süresi</th>
            </tr>
          </thead>
          <tbody className="text-gray-600">
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">Hesap bilgileri</td>
              <td className="py-2">Hesap aktif olduğu sürece</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">İlan verileri</td>
              <td className="py-2">İlan süresi + 6 ay</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">Mesaj geçmişi</td>
              <td className="py-2">2 yıl</td>
            </tr>
            <tr className="border-b border-gray-100">
              <td className="py-2 pr-4">İşlem güvenliği logları</td>
              <td className="py-2">1 yıl</td>
            </tr>
            <tr>
              <td className="py-2 pr-4">Hesap silme sonrası</td>
              <td className="py-2">30 gün içinde anonimleştirilir</td>
            </tr>
          </tbody>
        </table>
      </Section>

      <Section title="7. Veri Sahibi Olarak Haklarınız">
        <p className="mb-3">KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
        <ul className="list-[lower-alpha] pl-6 space-y-2">
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
          <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
          <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
          <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
          <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
          <li>KVKK'nın 7. maddesi kapsamında kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
          <li>Düzeltme, silme veya yok etme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
          <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
          <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
        </ul>
      </Section>

      <Section title="8. Veri Güvenliği Tedbirleri">
        <p className="mb-3">KVKK'nın 12. maddesi uyarınca aşağıdaki teknik ve idari tedbirler alınmaktadır:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>SSL/TLS şifreleme ile veri iletimi</li>
          <li>Veritabanı düzeyinde Row Level Security (RLS)</li>
          <li>Şifrelerin hash'lenerek saklanması</li>
          <li>Erişim kontrolleri ve yetkilendirme sistemi</li>
          <li>Düzenli güvenlik güncellemeleri ve denetimleri</li>
          <li>Çalışan eğitimi ve farkındalık programları</li>
          <li>Veri ihlali durumunda müdahale planı</li>
        </ul>
      </Section>

      <Section title="9. Veri İhlali Bildirimi">
        <p>
          Olası bir kişisel veri ihlali durumunda, KVKK'nın 12. maddesi uyarınca Kişisel Verileri
          Koruma Kurulu'na 72 saat içinde ve ilgili kişilere en kısa sürede bildirim yapılacaktır.
          Bildirimde ihlalın niteliği, etkilenen veri kategorileri, olası sonuçları ve alınan
          önlemler yer alacaktır.
        </p>
      </Section>

      <Section title="10. Başvuru Yöntemi">
        <p className="mb-3">
          Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki yöntemlerle başvurabilirsiniz:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Uygulama içi Ayarlar &gt; Gizlilik &gt; Veri Talebi bölümünden</li>
          <li>
            <a href="mailto:info@ubsbilisim.com" className="text-[#e77e23] hover:underline">info@ubsbilisim.com</a>
            {' '}adresine kimliğinizi doğrulayan bilgilerle birlikte e-posta göndererek
          </li>
        </ul>
        <p className="mt-3">
          Başvurular en geç 30 gün içinde ücretsiz olarak sonuçlandırılır. İşlemin ayrıca bir
          maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından belirlenen
          tarife uygulanabilir.
        </p>
      </Section>

      <Section title="11. Değişiklikler">
        <p>
          Bu aydınlatma metni gerektiğinde güncellenebilir. Güncellemeler uygulama içi bildirim
          ve/veya e-posta yoluyla kullanıcılara duyurulur.
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-[#111827] mb-3">{title}</h2>
      {children}
    </section>
  );
}
